var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20024 1.66992L0.676093 7.17246C0.648301 7.20022 0.628233 7.23528 0.618677 7.27295L0.00637773 9.7208C-0.0119379 9.79449 0.00980196 9.87285 0.0637932 9.92663C0.104645 9.96731 0.160309 9.98984 0.217246 9.98984C0.234686 9.98984 0.252524 9.9877 0.269884 9.98334L2.72752 9.3734C2.76583 9.36388 2.80063 9.34397 2.82842 9.31629L8.35305 3.81415L6.20024 1.66992Z",
    fill: "#48AB4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72238 0.91934L9.10745 0.306863C8.69647 -0.102486 7.98016 -0.102089 7.56966 0.306863L6.81641 1.05711L8.96913 3.20126L9.72238 2.45101C9.92767 2.24661 10.0408 1.97456 10.0408 1.68521C10.0408 1.39587 9.92767 1.12382 9.72238 0.91934Z",
    fill: "#48AB4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.fc9cedf1efdeafb6730eed993518c5f7.svg";
export { ForwardRef as ReactComponent };